/**
 * This is replaced by webpack's definePlugin
 * in next.config.js
 */
declare let __APP_ENV__: string;

export function getAppEnv(): string {
  return __APP_ENV__;
}
